import * as appApi from '@apis/app-feed';
import { Feed, FeedDataItem } from '@models/feed';
import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';

export const ChatIntroWarningEdit: React.FC<{
  clear?: boolean;
  data?: Partial<Feed<FeedDataItem>>;
  onChange?: (data: Partial<Feed<FeedDataItem>>) => void;
}> = (props) => {
  const [changedData, setChangedData] = useState<Feed<FeedDataItem>>();
  const { data } = props;
  const item = { ...data, ...changedData };

  useEffect(() => {
    if (props.clear) {
      setChangedData(undefined);
    }
  }, [props.clear]);

  useEffect(() => {
    if (changedData) {
      props.onChange && props.onChange({ ...data, ...changedData });
    }
  }, [changedData]);

  return (
    <div>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
        <div>채팅 시작 시 주의사항</div>
        <Button
          onClick={() => {
            appApi.getPlaceholders().then((response) => {
              const chatParentWarningMent = response.data.chatParentWarningMent;
              const chatTutorWarningMent = response.data.chatTutorWarningMent;
              setChangedData((prev) => {
                return {
                  ...prev,
                  type: 'chat-intro-warnings',
                  data: [
                    { type: 'parent', description: chatParentWarningMent },
                    { type: 'tutor', description: chatTutorWarningMent },
                  ],
                } as Feed<FeedDataItem>;
              });
            });
          }}>
          구 데이터 불러오기
        </Button>
      </div>

      <div style={{ marginBottom: '8px', marginTop: '12px' }}>
        <div style={{ fontWeight: 'bold' }}>부모 화면</div>
        <Input.TextArea
          style={{ width: '428px', height: '140px' }}
          value={(item?.data && item.data.length > 0 && item.data[0]?.description) || ''}
          onChange={(e) => {
            setChangedData((prev) => {
              const newData = [...(prev?.data || item?.data || [])];
              newData[0] = { type: 'parent', description: e.target.value };
              return { ...prev, type: 'chat-intro-warnings', data: newData } as Feed<FeedDataItem>;
            });
          }}></Input.TextArea>
      </div>
      <div style={{ marginBottom: '8px', marginTop: '12px' }}>
        <div style={{ fontWeight: 'bold' }}>튜터 화면</div>
        <Input.TextArea
          style={{ width: '428px', height: '140px' }}
          value={(item?.data && item.data.length > 0 && item.data[1]?.description) || ''}
          onChange={(e) => {
            setChangedData((prev) => {
              const newData = [...(prev?.data || item?.data || [])];
              newData[1] = { type: 'tutor', description: e.target.value };
              return { ...prev, type: 'chat-intro-warnings', data: newData } as Feed<FeedDataItem>;
            });
          }}></Input.TextArea>
      </div>
    </div>
  );
};

export default ChatIntroWarningEdit;
